import {createApp} from 'vue'
import ActionResponseBox from './ActionResponseBox'

const el = '.kb-component--action-response-box'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ActionResponseBoxDOM)=>{
            const props = {
                actionResponseText: ActionResponseBoxDOM.dataset.actionResponseText,
                lifeTime: Number(ActionResponseBoxDOM.dataset.lifeTime),
                fadeDuration: Number(ActionResponseBoxDOM.dataset.fadeDuration)
            }
            const component = createApp(ActionResponseBox, props).use(Store)
            component.mount(ActionResponseBoxDOM)
        })
    }
}